import api from '../utils/api';

// Fetch all student cards
export const getStudentCards = async (headers) => {
  try {
    const response = await api.get('/api/studentcards', headers);
    console.log("Student Cards:", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching student cards:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific student card by ID
export const getStudentCardById = async (id, headers) => {
  try {
    const response = await api.get(`/api/studentcards/${id}`, headers);
    console.log("Student Card by ID:", response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching student card with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new student card
export const createStudentCard = async (studentCardData, headers) => {
  try {
    const response = await api.post('/api/studentcards', studentCardData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating student card:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a student card
export const deleteStudentCard = async (id, headers) => {
  try {
    const response = await api.delete(`/api/studentcards/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting student card with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// update a student card
export const updateStudentCard = async (id, headers) => {
  try {
    const response = await api.put(`/api/studentcards/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting student card with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};